<script setup lang="ts">
  import { FormFieldContainer, useXPathAction } from '@logistiek-zonder-papier/lzp-library'
  import { computed } from 'vue'

  const model = defineModel<string>({ required: true })

  const props = withDefaults(
    defineProps<{
      label?: string | null
      optional: boolean
      error?: string | null
      warning?: string | null
      placeholder?: string
      validatePaths?: boolean
    }>(),
    { validatePaths: false, optional: false }
  )

  const xpath = useXPathAction()

  const resolved = computed(() => {
    const path = model.value?.trim()
    if (!path) return undefined
    return xpath.resolvePath(path)
  })

  const state = computed<'grey' | 'green' | 'red'>(() => {
    if (!props.validatePaths) return 'grey'
    return resolved.value === undefined ? 'red' : 'green'
  })

  const hint = computed(() =>
    resolved.value === undefined ? 'undefined' : JSON.stringify(resolved.value)
  )
</script>

<template>
  <FormFieldContainer :label="label" :optional="optional" :error="error" :warning="warning">
    <input
      class="direct-path"
      :class="state"
      type="text"
      spellcheck="false"
      v-model="model"
      :placeholder="placeholder"
      :title="hint"
    />
  </FormFieldContainer>
</template>

<style scoped>
  .direct-path {
    display: block;
    width: 100%;
    min-height: var(--components-component-height, 2.5rem);
    padding: 0.5rem 0.75rem;
    border: 1px solid rgb(209, 213, 219);
    border-radius: 0.375rem;
    background: var(--colours-grey-1, #fff);
    font-family: ui-monospace, monospace;
    font-size: 0.875rem;
    outline: none;
    transition:
      border-color 120ms ease,
      background 120ms ease;
  }
  .direct-path:focus {
    border-color: var(--colours-brand-colour-1);
  }
  .direct-path.green {
    border-color: rgb(16, 185, 129);
    background: rgb(236, 253, 245);
  }
  .direct-path.red {
    border-color: rgb(239, 68, 68);
    background: rgb(254, 242, 242);
  }
</style>
